import React from "react";
import PublicV2Layout from "../layout/PublicV2Layout";
import PrivacyPolicy from "../../pages/PrivacyPolicy-TOS/PrivacyPolicy";
import "./privacyTosV2.css";

/**
 * v2 chrome around the existing Privacy Policy. The legal text is reused as a
 * single source of truth (copying it would risk drift on legal content). The
 * inner component supplies its own <Helmet> title/description (already matches
 * prod SEO), so the layout only adds the noindex tag.
 */
const PrivacyV2 = (navProps) => (
  <PublicV2Layout {...navProps}>
    <div className="bdrv2-doc bdrv2-section">
      <div className="bdrv2-container">
        <PrivacyPolicy />
      </div>
    </div>
  </PublicV2Layout>
);

export default PrivacyV2;
